import {Model} from "@vuex-orm/core";

export default class Stopover extends Model {

    static entity = 'flightStopovers';

    static primaryKey = ['flight_id', 'airport_id'];

    static fields () {
        return {
            flight_id: this.number(null).nullable(),
            airport_id: this.number(null).nullable(),
        }
    }
}
